import type { TZaiChatParamsKey } from './zai.types'

export const ZAI_CHAT_PARAMS_KEY = {
  threadId: 'thread_id',
  threadPrompt: 'thread_prompt',
  threadPromptPage: 'thread_prompt_page',
  redirectUrl: 'redirect_url',
  promptVariant: 'prompt_variant',
  ragEnabled: 'rag_enabled',
  theme: 'theme',
  quickPromptId: 'quick_prompt_id',
} as const satisfies Record<string, TZaiChatParamsKey>

export const ZAI_QUESTION_TYPE = {
  PROMPT: 'prompt' as const,
  SIMPLE: 'simple' as const,
}
